import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { GroupService } from 'src/app/group/group.service';
import { MembersFileSendComponent } from 'src/app/members/members-file-send/members-file-send.component';
import { MembersService } from 'src/app/members/members.service';
import { User } from 'src/app/shared/interfaces/user.interface';
import { CITIES } from 'src/app/shared/static/cities.json';
import { states } from 'src/app/shared/static/states';
import { getFileUrl } from 'src/app/utils/getFileUrl';
import { AccountService } from '../services/account.service';
import { UserService } from '../services/user.service';

@Component({
  selector: 'app-profile-form',
  templateUrl: './profile-form.component.html',
  styleUrls: ['./profile-form.component.css'],
})
export class ProfileFormComponent implements OnInit {
  form: FormGroup;
  disciplers: User[];
  user: User;
  bloods = ['A+', 'B+', 'O+', 'AB+', 'A-', 'B-', 'O-', 'AB-'];
  states = states;
  cities = [];
  currentAvatar;

  constructor(
    private memberService: MembersService,
    private accountService: AccountService,
    private activeRouter: ActivatedRoute,
    private toastr: ToastrService,
    private groupService: GroupService,
    private router: Router,
    private matDialog: MatDialog,
    private userService: UserService
  ) {
    this.makeForm();
    this.getUser();
    this.getDisciplers();
  }

  ngOnInit(): void {}

  makeForm() {
    this.form = new FormGroup({
      name: new FormControl('', Validators.required),
      gender: new FormControl('', [Validators.required]),
      email: new FormControl('', [Validators.required, Validators.email]),
      phone_number: new FormControl('', [Validators.required]),
      bhirth_date: new FormControl('', [Validators.required, Validators.maxLength(10)]),
      state_id: new FormControl('', []),
      city_id: new FormControl('', []),
      street: new FormControl('', [Validators.required, Validators.minLength(5)]),
      home_number: new FormControl('', [Validators.required]),
      complement: new FormControl('', []),
      blood_type: new FormControl(''),
      cpf: new FormControl(null, [Validators.required]),
      group_id: new FormControl('', []),
      discipler_id: new FormControl('', []),
      group_function_id: new FormControl('', []),
    });
  }

  getUser() {
    this.accountService.get().then((res) => {
      this.user = res;
      if (res.avatar?.file_name) {
        sessionStorage.setItem('userAvatar', res.avatar?.file_name);
        this.userService.setUserData('');
      }
      let {
        name,
        gender,
        email,
        phone_number,
        bhirth_date,
        city_id,
        state_id,
        street,
        home_number,
        complement,
        blood_type,
        cpf,
        group_id,
        discipler_id,
        group_function_id,
      } = res;

      if (bhirth_date) {
        bhirth_date = String(bhirth_date).substr(0, 10);
      }
      this.form.setValue({
        name,
        gender,
        email,
        phone_number,
        bhirth_date,
        city_id,
        state_id,
        street,
        home_number,
        complement,
        blood_type,
        cpf,
        group_id,
        discipler_id,
        group_function_id,
      });

      this.currentAvatar = getFileUrl(res);
    });
  }

  disableInputs() {
    this.form.controls['email'].disable();
    this.form.controls['cpf'].disable();
  }

  getDisciplers() {
    this.memberService.get().then((res) => {
      this.disciplers = res;
    });
  }

  update() {
    if (!this.form.valid) {
      this.form.errors;
      return null;
    }
    this.accountService.update(this.form.value).then((res) => {
      this.toastr.success(res.message);
      sessionStorage.setItem('userName', this.form.get('name').value);
      this.userService.setUserData(this.form.get('name').value);
      this.form.reset();
    });
  }

  changeCity(CurrentState): void {
    if (CurrentState) {
      const citiesTemp = CITIES.filter((s) => {
        if (s.Estado == CurrentState) {
          return s;
        }
      });
      this.cities = citiesTemp;
    }
  }

  changeAvatar() {
    const dialog = this.matDialog
      .open(MembersFileSendComponent, {
        width: '400px',
        height: '600px',
        data: {
          id: this.user.id,
        },
      })
      .afterClosed()
      .subscribe((afterClosedResult) => {
        afterClosedResult ? this.getUser() : null;
      });
  }
}
